// extracted by mini-css-extract-plugin
export default {"root":"newProducts_root__I12Ih","title":"newProducts_title__AjxDp","waves":"newProducts_waves__bc4Ub"};